document.addEventListener('DOMContentLoaded', () => {
  function hasPreorderItem(context = document) {
    const items = context.querySelectorAll('.cart__item');
    for (const item of items) {
      const policy = item.dataset.inventoryPolicy;
      const quantity = parseInt(item.dataset.inventoryQuantity || '0', 10);

      if (policy === 'continue' && quantity <= 0) {
        return true;
      }
    }
    return false;
  }

  function updatePreorderDisplay() {

    setTimeout(() => {
      const locations = ['#CartDrawer', '#CartPageForm'];

      console.log('here')

      locations.forEach(selector => {
        const context = document.querySelector(selector);
        if (!context) return;

        let preorderBanner = context.querySelector('[data-preorder-banner]');
        if(selector == '#CartPageForm') {
            preorderBanner = document.querySelector('.template-cart .main-content [data-preorder-banner]');
        }
        const preorderNote = context.querySelector('[data-preorder-note]');
        const defaultNote = context.querySelector('.default-cart-shipping-note');

        const preorderActive = hasPreorderItem(context);
     
        if (preorderBanner) {
          preorderBanner.style.display = preorderActive ? 'block' : 'none';
        }

        if (preorderNote) {
          preorderNote.style.display = preorderActive ? 'block' : 'none';
        }

        if (defaultNote) {
          defaultNote.style.display = preorderActive ? 'none' : 'block';
        }
      });
    }, 1000);
  }

  document.addEventListener('cart:updated', updatePreorderDisplay);
  document.addEventListener('ajaxProduct:added', updatePreorderDisplay);

  updatePreorderDisplay();
});
